var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTellyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 65,
    viewBox: "0 0 145 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_715)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 145,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.02 0H0V65H144.02V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.362 2.05347H2.03827L0 12.9195H12.7303L5.50692 50.7452H17.37L24.5934 12.9195H37.3238L39.362 2.05347Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9249 19.0525C57.8764 16.224 53.6388 14.665 48.9812 14.665C43.2508 14.665 38.3607 16.7468 34.8384 20.6862C31.504 24.4201 29.6713 29.6385 29.6713 35.3703C29.6713 40.2431 31.3966 44.3598 34.6687 47.2818C37.7529 50.0357 42.1155 51.5572 46.952 51.5572C54.6938 51.5572 61.4524 47.3003 64.5901 40.4578L64.8227 39.9443H53.755L53.6569 40.0656C52.2175 41.7088 49.9022 42.6889 47.4793 42.6889C45.4232 42.6889 43.7067 42.0915 42.4999 40.9713C41.4003 39.9443 40.7566 38.4974 40.6226 36.7611H65.1981L65.2696 36.4997C65.6629 34.9968 65.8686 32.6164 65.8686 31.1321C65.8686 26.2405 64.1611 22.0585 60.9249 19.0619V19.0525ZM48.722 23.132C50.644 23.132 52.289 23.7948 53.469 25.055C54.5418 26.1939 55.1498 27.7808 55.2033 29.5358H41.3287C41.6863 27.678 42.5177 26.1097 43.7426 24.9896C45.0656 23.776 46.7909 23.132 48.722 23.132Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.918 0L67.2004 50.7453H78.6701L88.3879 0H76.918Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9126 0L84.195 50.7453H95.6647L105.382 0H93.9126Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.791 15.4873L121.546 35.9497L118.515 15.4873H106.902L113.196 48.3373L104.238 65.0004H116.388L124.228 50.5684L144.02 15.4873H131.791Z",
    fill: "#F9423A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellyLogo);
export default __webpack_public_path__ + "static/media/TellyLogo.5c416a74e0f956726dd075df8a7bddad.svg";
export { ForwardRef as ReactComponent };